import * as React from "react";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { IUsagesSearchQuery } from "../../../types/usageTypes/IUsagesSearchQuery";
import { IMatchWorksSearchQuery } from "../../../types/usageTypes/IMatchWorksSearchQuery";
import { IUsageGroupResult, IUsageGroupsSearchResult, IUsageSearchResultRowType } from "../../../types/usageTypes/IUsageGroupsSearchResult";
import { IExternalLink } from "../../../types/IExternalLink";
import { IMatchWorksSearchResult } from "../../../types/usageTypes/IMatchWorksSearchResult";
import CustomButton from "../customButton/CustomButton";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { useEffect } from "react";
import { SearchRequests } from '../../../services/SearchRequests';

import {
    EMPTY_STRING_VALUE,
    SEARCH_VIEW_USAGES,
    DISTRIBUTION_SEARCH_USAGES_STATE_KEY,
    SOURCEMAJOR_SEARCH_USAGES_STATE_KEY,
    SOURCEMINOR_SEARCH_USAGES_STATE_KEY,
    USAGE_MATCHING_WORKS_SECTION_KEY,
    REPERTOIRE,
    USAGETOWORK,
    USAGETOPRODUCT,
    POOL_SEARCH_USAGES_STATE_KEY,
    SEARCH_VIEW_HAS_OPEN_WORKFLOW,
    DONOTCARE_ABOUTWORKFLOWS,
    WITHOUTOPEN_WORKFLOWS,
    HASOPEN_WORKFLOWS,
    WORK_IS_DISTRIBUTED_STATE_KEY,
    REG_DATE_STATE_KEY,
    USAGETYPE_SEARCH_USAGES_STATE_KEY,
    USAGETOPRODUCT_NO_SPACES,
    USAGE_GROUP_MATCH_STATUS_STATE_KEY,
    ADVANCED,
    REPERTOIRE_PAGE_FORM_ITEM_SIZE,
    USAGESEARCH_VIEW,
    SEARCH_VIEW_USAGES_USAGE_TO_WORK,
    SEARCH_VIEW_USAGES_USAGE_TO_PRODUCT,
    SEARCH_VIEW,
    SEARCH_VIEW_ARTISTS,
    SEARCH_VIEW_VENUES,
    SEARCH_VIEW_LICENSE_VENUES,
    PAYMENTRUN_DISTRIBUTION_CODE_STATE_KEY,
    USAGE_PAGE_FORM_ITEM_SIZE,
    USAGE_MATCHING_PRODUCTS_SECTION_KEY,
    SEARCH_VIEW_PRODUCTS,
    USAGE_SEARCH_SOURCE_COSMOS,
    USAGE_MAINTENANCE_PAGE_KEY,
    USAGE_DETAILS_ROWS_SECTION_KEY,
    BULK_USAGE_IP_ADJUSTMENT_CONFIRM_VIEW
} from "../../../Consts";
import { InputSizedDropdown } from "../../usageComponents/dropdownInput/DropdownInput";
import TextDataInput from "../../usageComponents/textInput/TextInput";
import { IInlineActionButtonWrapper } from "../../usageComponents/textInput/TextInput";
import { ResultsTable } from "../resultTable/ResultsTable";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { getLookupValues, mapLookupKey, mapUsageLookupKey } from "../../../../lookup/services/LookupHelpers";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { hideModal } from "../../../../redux/reducers/ModalReducer";
import { addMatchWorkToUsage, searchDataChanged, addMatchProductToUsage, updateUsageGroupMatches, addWorkOrProductToUsageSearchCriteria, updateAdjustmentField } from "../../../../redux/reducers/RepertoireReducer";
import { IMatchProductsSearchQuery } from "../../../types/usageTypes/IMatchProductsSearchQuery";
import { IProductSearchResult } from "../../../types/IProductSearchResult";
import { SizedDropdownTreeDataInput } from "../../dropdownTreeDataInput/DropdownTreeDataInput";
import { ITreeData } from "../../../types/ITreeData";
import { ReactElement } from "react";
import { SizedRadiobuttonDataInput } from "../../radioButtonDataInput/RadiobuttonDataInput";
import { ComponentsHelper } from "../../../../core/services/ComponentHelper";
import { SizedCheckboxDataInput } from "../../checkboxDataInput/CheckboxDataInput";
import SizedDateDataInput from "../../dateDataInput/DateDataInput";
import { IDistributionType } from "../../../types/usageTypes/IDistibutionType";
import { IUsageGroupState } from "../../../../redux/types/IUsageGroupState";
import { If } from "../../../../core/components/If";
import ShowMore from "../../showMore/ShowMore";
import InputWithKebabMenu from "../../inputWithKebabMenu/InputWithKebabMenu";
import SelectionTable from "../../../components/usageComponents/selectionTable/SelectionTable";
import SearchViewKeyEventListener from "../../searchView/SearchViewKeyEventListener";
import { IUsagePoolSearchQuery } from "../../../types/usageTypes/IUsagePoolSearchQuery";
import { IUsagePool } from "../../../types/usageTypes/IUsagePool";
import { IAdjustmentDetails } from "../../../../redux/types/IAdjustmentDetails";
import { IAdjustmentState, IAdjustmentStateKeys } from "../../../../redux/types/IAdjustmentState";
import { IDistributionSearchQuery } from "../../../types/usageTypes/IDistributionSearchQuery";
import { IDistribution } from "../../../types/usageTypes/IDistribution";
import { EXTERNAL_SVG } from "../../../IconConsts";
import { IUsageSearcResultConfiguration } from "../../../types/usageTypes/IUsageSearcResultConfiguration";
import { AllocationHeaderRowType } from "../../../types/usageTypes/IAllocationRowTypes";
import { IComponentView } from "../../../../redux/types/ComponentView";
import { isMandatoryField } from "../../../../util/tools";
import { IComponentViewsPreference } from "../../../../redux/types/IComponentViewsPreference";
import { PRODUCT_SOURCE_LOOKUP, PRODUCT_STATUS_TYPE_LOOKUP } from "../../../../lookup/Consts";
import { IAdjustmentDetailsToSocietyAffiliation } from "../../../types/ISocietyAffiliation";
import { IApplyMatchToMultipleRecordsRequest } from "../../../types/usageTypes/IApplyMatchToMultipleRecordsRequest";
import { IApplyMatchToMultipleRecordsResponse } from "../../../types/usageTypes/IApplyMatchToMultipleRecordsResponse";
import { IBulkMatchTarget } from "../../../types/usageTypes/IBulkMatchTarget";
import UsageBulkMatchPanel from "./bulkMatching/UsageBulkMatchPanel";
import {
    buildBulkMatchRequest,
    deriveBulkTargetSearchDefaults,
    mapProductToBulkMatchTarget,
    mapWorkToBulkMatchTarget
} from "./bulkMatching/usageBulkMatchUtils";
import { IBulkTargetSearchDefaults, UsageBulkMatchSearchResult } from "./bulkMatching/usageBulkMatchTypes";
import { IDropdownOption } from "@fluentui/react";
import SearchableMultiSelectComboBox from "./searchableMultiSelect/SearchableMultiSelectComboBox";
import { buildUniqueCodeDropdownOptions, getDistributionOptions as buildDistributionOptions } from "./UsageSearchHelper";
import { IBulkUsageIpAdjustmentIP, IBulkUsageIpAdjustmentRequest } from "../../../types/usageTypes/IBulkUsageIpAdjustmentRequest";
import { IBulkUsageIpAdjustmentResponse } from "../../../types/usageTypes/IBulkUsageIpAdjustmentResponse";
import UsageBulkAdjustmentPanel from "./bulkAdjustment/UsageBulkAdjustmentPanel";
import { IP } from "../../../types/IP";

const MAX_INITIAL_USAGE_SEARCH_OPTIONS = 1000;
export interface IUsageSearchViewProps {
    searchViewData: IRepertoireComponentDataItem;
    bulkTargetSearchViewData?: IRepertoireComponentDataItem;
    searchResultsTableData: IRepertoireComponentDataItem;
    searchSuccessful: boolean;
    componentInstance: string;
    modalProps: any;
    searchUsages?: (query: IUsagesSearchQuery, modalOpen: boolean, usageType: string, lookupSources: ITreeData[], continuationToken?: string, externalLinks?: IExternalLink[]) => void;
    submitBulkMatch?: (request: IApplyMatchToMultipleRecordsRequest) => Promise<IApplyMatchToMultipleRecordsResponse>;
    canUpdateUsages?: boolean;
    canBulkAdjust?: boolean;
    submitBulkAdjustment?: (request: IBulkUsageIpAdjustmentRequest) => Promise<IBulkUsageIpAdjustmentResponse>;
    searchMatchWorks?: (query: IMatchWorksSearchQuery, modalOpen: boolean, lookupValues?: ILookupDictionary) => void;
    searchMatchProducts?: (query: IMatchProductsSearchQuery, modalOpen: boolean) => void;
    onSelectResult?: (selectedResult: UsageBulkMatchSearchResult) => void;
    initialSearchValues?: IBulkTargetSearchDefaults;
    usageGroupsSearchResult?: IUsageGroupResult[];
    matchWorkSearchResult?: IMatchWorksSearchResult[];
    matchProductsSearchResult?: IProductSearchResult[];
    activeTab?: number;
    tabs?: ITabReduxItem[];
    scroll?: number;
    toolbarWidth?: number;
    dataGridTableData?: IRepertoireComponentDataItem;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    currentPage?: number;
    resetPagination: (repertoireSection: string) => void;
    setIsHundredResultsPerPage?: (isHundredResultsPerPage: boolean) => void;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    sourceMajors?: { code: string; description: string; }[];
    sourceMinors?: { code: string; description: string; }[];
    getUsageDetails: (usageID: string, lookups: ILookupDictionary, openEntityForWorflowSession?: boolean) => void;
    getDistributionDetails?: (distributionID: number, lookupValues: ILookupDictionary) => void;
    getUsagePool?: (poolId: number, matchingSources: ITreeData[], isPoolMaintainence?: boolean) => void;
    distributions?: { id: number; code: string; description: string; }[];
    pools?: { id: number; code: string; description: string; }[];
    lookupValues?: ILookupDictionary;
    sourceMajor?: { code: string; description: string; }[];
    sourceMinor?: { code: string; description: string; }[];
    allocationStatus?: { code: string; description: string; }[];
    includeFeesInError?: { code: string; description: string; }[];
    matchStatus?: { code: string; description: string; }[];
    showModal?: (
        modalContent: string,
        modalComponentInstance: string,
        modalProps: any,
        displayModalCloseButton: boolean,
        title: string
    ) => void;
    hideModal: typeof hideModal;
    expandedMatchWorkResults?: number[];
    usageExpandAll?: boolean,
    usageExpandAllResults?: () => void;
    expandMatchWorkResult: (matchWorkResults: number) => void;
    addMatchworkToUsage?: typeof addMatchWorkToUsage;
    addMatchProductToUsage?: typeof addMatchProductToUsage;
    searchDataChanged: typeof searchDataChanged;
    usageType?: string;
    searchSource?: string;
    onClickNumber?: (id: number) => void;
    lookupSources?: ITreeData[];
    onlySearchResults?: boolean;
    isDistributed?: boolean;
    dateOfRegistration?: string;
    sortSearchResults?: (name: string, results: any) => void;
    distributionTypes: IDistributionType[];
    usageGroup?: IUsageGroupState;
    continuationToken?: string;
    externalLinks?: IExternalLink[];
    showFieldsModal?: (componentFieldName: string) => void;
    searchDisabled?: boolean;
    updateUsageGroupMatches?: typeof updateUsageGroupMatches;
    saveUsageGroup?: (updatedUsageGroup: IUsageSearchResultRowType) => void;
    saveResultData?: IRepertoireComponentDataItem;
    searchType?: string;
    expanderFieldsData?: IRepertoireField[];
    matchingEntityForUsageSearchCriteria?: { id: number, number: string };
    addWorkOrProductToUsageSearchCriteria?: typeof addWorkOrProductToUsageSearchCriteria;
    usageMatchingDefaultsWorks?: string[];
    usageMatchingDefaultsProducts?: string[];
    isHundredResultsPerPage?: boolean;
    matchingSources?: ITreeData[];
    searchUsagePoolsByCodeDistributionPools?: (query: IUsagePoolSearchQuery) => void;
    poolCodeToSearch?: string;
    updatePoolCodeToSearch?: (value: string) => void;
    customer?: string;
    usagePoolsSearchResults?: IUsagePool[];
    getWorkDetails?: (tableItem?: any, event?: React.MouseEvent) => void;
    getProductDetails?: (tableItem?: any, event?: React.MouseEvent, openInSecondTabDueToOrigin?: boolean) => void;
    updateAdjustmentDetail?: (value?: any, affiliations?: IAdjustmentDetailsToSocietyAffiliation[]) => void;
    adjustmentDetails?: IAdjustmentDetails[];
    adjustment?: IAdjustmentState;
    workAdjustmentIndex?: number;
    searchDistributionByCode?: (query: IDistributionSearchQuery) => void;
    distributionCodeToSearch?: string;
    updateDistributionCodeToSearch?: (value: string) => void;
    usageDistributionsSearchResults?: IDistribution[];
    updateAdjustmentField?: (value: any, fieldName: IAdjustmentStateKeys) => void;
    usageSearchResultConfiguration?: IUsageSearcResultConfiguration;
    settingsModalViewData?: IRepertoireComponentDataItem;
    componentViews?: any;
    enabledAdjustmentICEWorkSearch?: boolean;
    allocationRecords?: AllocationHeaderRowType[];
    usageSearchResultsActiveComponentView?: IComponentView;
    setActiveComponentView?: (activeComponentView: any) => void;
    userIsConfigureComponentViewAdmin?: boolean;
    componentViewPreference?: IComponentViewsPreference;
    searchArtistValue?: string;
    searchCustomerVenueCodeValue?: string;
    searchLicenseCustomerVenueCodeValue?: string;
    searchCustomerVenueValue?: string;
    searchLicenseCustomerVenueValue?: string;
    usageNumberInSearchExclude?: string[];
    onUsageGroupSelected?: (usageGroup: IUsageSearchResultRowType) => void;
    singleUsageGroupSelection?: boolean;
    disableUsageOpen?: boolean;
}

const initialState = () => {
    return {
        tableContents: [],
        type: EMPTY_STRING_VALUE,
        distributionsFilter: [],
        poolsFilter: [],
        searchSource: EMPTY_STRING_VALUE,
        fileName: "",
        title: "",
        composer: "",
        artist: "",
        sourceMajor: null,
        sourceMinor: EMPTY_STRING_VALUE,
        rightShareOwner: "",
        allocationStatus: EMPTY_STRING_VALUE,
        includeFeesInError: EMPTY_STRING_VALUE,
        totalWeight: "",
        licenseesWorkNumber: "",
        matchStatus: EMPTY_STRING_VALUE,
        setPageOne: 0,
        number: "",
        writers: "",
        societyAccountNumber: "",
        workBatchID: "",
        dataSource: REPERTOIRE,
        hasOpenWorkflow: null,
        productBatchID: "",
        contributor: "",
        productType: "",
        artistAdvancedSearch: "",
        customerAdvancedSearch: "",
        venueAdvancedSearch: "",
        matches: "",
        matchID: null,
        titleContains: '',
        sourcesFilter: null,
        approvalStatus: EMPTY_STRING_VALUE,
        qaStatus: EMPTY_STRING_VALUE,
        weight: "",
        estimatedValue: 0,
        estimatedFromValue: "",
        estimatedToValue: "",
        isLoading: false,
        performanceNumberType: "",
        performanceNumber: "",
        fromDate: null,
        toDate: null,
        usageUse: "",
        programName: "",
        carrierType: "",
        dimension1: "",
        dimension2: "",
        dimension3: "",
        dimension4: "",
        dimension5: "",
        venueName: "",
        ipName: "",
        ipiNameNumber : "",
        licensingSystemID: "",
        artistNameAdvancedSearch: "",
        customerCodeAdvancedSearch: "",
        venueCodeAdvancedSearch: "",
        status: "",
        source: "",
        pageSize: 250,
        selectedUsageGroupIds: [],
        bulkMatchPanelOpen: false,
        bulkMatchTarget: null,
        bulkMatchSubmitting: false,
        bulkMatchSearchStarted: false,
        bulkAdjustmentPanelOpen: false,
        bulkAdjustmentSubmitting: false,
        bulkAdjustmentFromIP: null,
        bulkAdjustmentToIP: null,
    };
}

interface IUsageSearchViewState {
    tableContents: IUsageGroupsSearchResult[] | IMatchWorksSearchResult;
    type: string;
    distributionsFilter: string[];
    poolsFilter: string[];
    searchSource: string;
    fileName: string;
    title: string;
    composer: string;
    artist: string;
    sourceMajor: number;
    sourceMinor: string;
    rightShareOwner: string;
    allocationStatus: string;
    includeFeesInError: string;
    totalWeight: string;
    licenseesWorkNumber: string;
    matchStatus: string;
    setPageOne: number;
    number: string;
    writers: string;
    societyAccountNumber: string;
    workBatchID: string;
    dataSource: string;
    hasOpenWorkflow: boolean;
    productBatchID: string;
    contributor: string;
    productType: string;
    artistAdvancedSearch: string;
    customerAdvancedSearch: string;
    venueAdvancedSearch: string;
    matches: string;
    matchID: number;
    titleContains: string;
    sourcesFilter: string[];
    matchingWork?: string;
    matchingProduct?: string;
    approvalStatus?: string;
    qaStatus?: string;
    weight: string;
    estimatedValue?: number;
    estimatedFromValue?: string;
    estimatedToValue?: string;
    matchingSources?: ITreeData[];
    isLoading?: boolean;
    performanceNumberType?: string,
    performanceNumber?: string;
    fromDate?: Date;
    toDate?: Date;
    usageUse: string;
    programName: string;
    carrierType: string;
    dimension1: string;
    dimension2: string;
    dimension3: string;
    dimension4: string;
    dimension5: string;
    venueName: string;
    ipName: string;
    ipiNameNumber : string;
    licensingSystemID: string;
    artistNameAdvancedSearch: string;
    customerCodeAdvancedSearch: string;
    venueCodeAdvancedSearch: string;
    status: string;
    source: string;
    pageSize: number;
    selectedUsageGroupIds: string[];
    bulkMatchPanelOpen: boolean;
    bulkMatchTarget: IBulkMatchTarget | null;
    bulkMatchSubmitting: boolean;
    bulkMatchSearchStarted: boolean;
    bulkAdjustmentPanelOpen: boolean;
    bulkAdjustmentSubmitting: boolean;
    bulkAdjustmentFromIP: IBulkUsageIpAdjustmentIP | null;
    bulkAdjustmentToIP: IBulkUsageIpAdjustmentIP | null;
}

interface IUsageSearchViewDataKeys {
    type: string;
    distributionsFilter: string[];
    poolsFilter: string[];
    fileName: string;
    title: string;
    composer: string;
    artist: string;
    sourceMajor: string;
    sourceMinor: string;
    rightShareOwner: string;
    allocationStatus: string;
    includeFeesInError: string;
    totalWeight: string;
    licenseesWorkNumber: string;
    matchStatus: string;
    number: string;
    writers: string;
    societyAccountNumber: string;
    workBatchID: string;
    dataSource: string;
    hasOpenWorkflow: boolean;
    productBatchID: string;
    contributor: string;
    productType: string;
    matches: string;
    titleContains: string;
    sourcesFilter: string[];
    matchingWork: string;
    matchingProduct: string;
    weight: string;
    estimatedValue?: number;
    estimatedFromValue?: string;
    estimatedToValue?: string;
    matchingSources?: ITreeData[];
}

export type UsageSearchViewStateKeys = keyof IUsageSearchViewDataKeys;

export default class UsageSearchView extends React.PureComponent<
    IUsageSearchViewProps,
    IUsageSearchViewState
> {
    private sourceSelectionByUsageType: { [usageType: string]: number | null } = {};

    private bulkMatchSubmissionInFlight = false;
    private bulkAdjustmentSubmissionInFlight = false;

    private distributionOptionsCache: {
        distributions?: IUsageSearchViewProps["distributions"];
        searchResults?: IDistribution[];
        distributionPrefix?: string;
        selectedKeys?: string[];
        options: IDropdownOption[];
    } = {
        options: []
    };

    private poolOptionsCache: {
        pools?: IUsageSearchViewProps["pools"];
        searchResults?: IUsagePool[];
        selectedKeys?: string[];
        options: IDropdownOption[];
    } = {
        options: []
    };

    constructor(props: IUsageSearchViewProps) {
        super(props);

        this.state = {
            ...initialState(),
            ...(props.initialSearchValues ?? {})
        };
    }

    componentDidMount = () => {
        try {
            useEffect(() => {
                SearchRequests.getConfigurationParameter('UsageCosmosSearch', 'UsageMaintenance')
                    .then((pageSize) => {
                        this.setState({ pageSize: pageSize });
                    })
            }, []);
        } catch (e) {
            this.setState({ pageSize: 250 });
        }

        const { usageGroup, searchDataChanged, usageMatchingDefaultsProducts, usageMatchingDefaultsWorks, componentInstance } = this.props;
        let usageMatchingDefaults = componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY ? usageMatchingDefaultsWorks : []
        if (componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY) {
            usageMatchingDefaults = usageMatchingDefaultsProducts
        }
        if (usageMatchingDefaults && usageGroup) {

            let defaultVal: any = null;
            usageMatchingDefaults.map((fieldName) => {

                switch (fieldName) {
                    case "title":
                        defaultVal = usageGroup.fullTitle?.split('/')[0];
                        break;
                    case "artist":
                        defaultVal = usageGroup.fullPerformer?.split('/')[0];
                        break;
                    case "writers":
                        defaultVal = usageGroup.fullContributor?.split('/')[0];
                        break;
                    case "contributor":
                        defaultVal = usageGroup.fullContributor?.split('/')[0];
                        break;
                    case "productType":    
                        defaultVal = usageGroup.productType?.split('/')[0];
                        break;

                    default:
                        defaultVal = null;
                        break;

                }
                if (defaultVal) {
                    this.setState({
                        [fieldName]: defaultVal
                    } as Pick<IUsageSearchViewState, keyof IUsageSearchViewDataKeys>);

                    searchDataChanged(fieldName, defaultVal);
                }
            });

        }

    };

    componentDidUpdate = (prevProps: IUsageSearchViewProps, prevState: IUsageSearchViewState) => {
        const { usageType, matchingEntityForUsageSearchCriteria } = this.props;
        const { titleContains, distributionsFilter } = this.state;

        const previousSearchSource = prevProps.searchSource ?? USAGE_SEARCH_SOURCE_COSMOS;

        const currentSearchSource = this.props.searchSource ?? USAGE_SEARCH_SOURCE_COSMOS;

        const usageSearchContextChanged = prevProps.usageType !== this.props.usageType || previousSearchSource !== currentSearchSource;

        if (usageSearchContextChanged) {
            this.setState({
                selectedUsageGroupIds: [],
                bulkMatchPanelOpen: false,
                bulkMatchTarget: null,
                bulkAdjustmentPanelOpen: false,
                bulkAdjustmentFromIP: null,
                bulkAdjustmentToIP: null
            });
        }

        this.setState({
            tableContents: undefined
        });
        if (this.props.searchArtistValue !== prevProps.searchArtistValue) {
            this.setState({ artistAdvancedSearch: this.props.searchArtistValue || '' });
        }
        if (this.props.searchCustomerVenueValue !== prevProps.searchCustomerVenueValue || this.props.searchCustomerVenueCodeValue !== prevProps.searchCustomerVenueCodeValue) {
            this.setState({
                customerAdvancedSearch: this.props.searchCustomerVenueValue || '',
                customerCodeAdvancedSearch: this.props.searchCustomerVenueCodeValue || ''
            });
        }
        if (this.props.searchLicenseCustomerVenueValue !== prevProps.searchLicenseCustomerVenueValue || this.props.searchLicenseCustomerVenueCodeValue !== prevProps.searchLicenseCustomerVenueCodeValue) {
            this.setState({
                venueAdvancedSearch: this.props.searchLicenseCustomerVenueValue || '',
                venueCodeAdvancedSearch: this.props.searchLicenseCustomerVenueCodeValue || ''
            });
        }
        const usageSearchCompleted =
            this.props.componentInstance === SEARCH_VIEW_USAGES &&
            this.props.searchSuccessful !== undefined &&
            (prevProps.searchSuccessful !== this.props.searchSuccessful ||
                prevProps.usageGroupsSearchResult !== this.props.usageGroupsSearchResult);

        const matchingSearchCompleted =
            this.props.componentInstance !== SEARCH_VIEW_USAGES &&
            (prevProps.matchWorkSearchResult !== this.props.matchWorkSearchResult ||
                prevProps.usageGroupsSearchResult !== this.props.usageGroupsSearchResult ||
                prevProps.matchProductsSearchResult !== this.props.matchProductsSearchResult);

        if (usageSearchCompleted || matchingSearchCompleted) {
            this.setState({ isLoading: false });
        }
        if (prevProps.usageType !== usageType) {
            this.swapSourceSelectionForUsageType(prevProps.usageType, usageType);
        }
        if ((!prevState.titleContains && titleContains) || titleContains !== prevState.titleContains) {
            this.onClickSearch();
        }
        if (usageType === 'Usage To Work' && prevProps.matchingEntityForUsageSearchCriteria !== matchingEntityForUsageSearchCriteria) {
            this.setState(() => ({ matchingWork: matchingEntityForUsageSearchCriteria.number, matchID: matchingEntityForUsageSearchCriteria.id }));
        }
        else if (usageType === 'Usage To Product' && prevProps.matchingEntityForUsageSearchCriteria !== matchingEntityForUsageSearchCriteria) {
            this.setState(() => ({ matchingProduct: matchingEntityForUsageSearchCriteria.number, matchID: matchingEntityForUsageSearchCriteria.id }));
        }

        const newBulkWorkResultReceived =
            this.state.bulkMatchPanelOpen &&
            usageType === USAGETOWORK &&
            prevProps.matchWorkSearchResult !== this.props.matchWorkSearchResult;

        const newBulkProductResultReceived =
            this.state.bulkMatchPanelOpen &&
            usageType === USAGETOPRODUCT &&
            prevProps.matchProductsSearchResult !== this.props.matchProductsSearchResult;

        if ((newBulkWorkResultReceived || newBulkProductResultReceived) && !this.state.bulkMatchSearchStarted) {
            this.setState({
                bulkMatchSearchStarted: true
            });
        }
    };

    getDistributionOptions = (
        distributions: IUsageSearchViewProps["distributions"],
        searchResults: IDistribution[] | undefined,
        distributionPrefix: string | undefined,
        selectedKeys: string[]
    ): IDropdownOption[] => {
        const cache = this.distributionOptionsCache;

        if (
            cache.distributions === distributions &&
            cache.searchResults === searchResults &&
            cache.distributionPrefix === distributionPrefix &&
            cache.selectedKeys === selectedKeys
        ) {
            return cache.options;
        }

        const options = buildDistributionOptions(
            distributions,
            searchResults,
            distributionPrefix,
            selectedKeys
        );

        this.distributionOptionsCache = {
            distributions,
            searchResults,
            distributionPrefix,
            selectedKeys,
            options
        };

        return options;
    };

    getPoolOptions = (
        pools: IUsageSearchViewProps["pools"],
        searchResults: IUsagePool[] | undefined,
        selectedKeys: string[]
    ): IDropdownOption[] => {
        const cache = this.poolOptionsCache;

        if (
            cache.pools === pools &&
            cache.searchResults === searchResults &&
            cache.selectedKeys === selectedKeys
        ) {
            return cache.options;
        }

        const baseItems = (pools ?? [])
            .map(pool => ({
                code: pool.code,
                description: pool.description
            }));

        const searchedItems = (searchResults ?? [])
            .map(pool => ({
                code: pool.poolCode,
                description: pool.description
            }));

        const selectedItems =
            selectedKeys.map(code => ({
                code,
                description: code
            }));

        let options =
            buildUniqueCodeDropdownOptions([
                ...baseItems,
                ...searchedItems,
                ...selectedItems
            ]);

        const hasSearchedResults = Boolean(searchResults?.length);

        if (!hasSearchedResults && options.length > MAX_INITIAL_USAGE_SEARCH_OPTIONS) {
            const selectedOptions = options.filter(option => selectedKeys.includes(String(option.key)));

            options = options.slice(0, MAX_INITIAL_USAGE_SEARCH_OPTIONS);

            selectedOptions.forEach(selectedOption => {
                if (!options.some(option => option.key === selectedOption.key)) {
                    options.unshift(selectedOption);
                }
            });
        }

        this.poolOptionsCache = {
            pools,
            searchResults,
            selectedKeys,
            options
        };

        return options;
    };

    swapSourceSelectionForUsageType = (previousUsageType: string, nextUsageType: string) => {
        const { searchDataChanged } = this.props;
        const { sourceMajor } = this.state;

        if (previousUsageType) {
            this.sourceSelectionByUsageType[previousUsageType] = sourceMajor;
        }

        const restoredSourceMajor = nextUsageType && nextUsageType in this.sourceSelectionByUsageType
            ? this.sourceSelectionByUsageType[nextUsageType]
            : null;

        this.setState({ sourceMajor: restoredSourceMajor });
        searchDataChanged(SOURCEMAJOR_SEARCH_USAGES_STATE_KEY, restoredSourceMajor);
    };

    changeData = (value: any, fieldName: IRepertoireStateKeys) => {
        const { searchDataChanged } = this.props;

        this.setState({
            [fieldName]: value
        } as Pick<IUsageSearchViewState, keyof IUsageSearchViewDataKeys>);        

        searchDataChanged(fieldName, value);
    };

    handleMatchingWorkOrProductChange = (value: any, fieldName: IRepertoireStateKeys) => {
        const { searchDataChanged } = this.props;
        if (this.disabledSearchFields(fieldName)) return;
        if (fieldName === 'matchingWork' || fieldName === 'matchingProduct') {
            this.setMatchingWorkTitle(value);
        }
        this.setState({
            [fieldName]: value
        } as Pick<IUsageSearchViewState, keyof IUsageSearchViewDataKeys>);        
        searchDataChanged(fieldName, value);
    }

    getMatchingWorkOrProductValue = (fieldName: string, condition: boolean, matchingWorkTitle: string, stateValue: string) => {
       return condition && (fieldName === 'matchingWork' || fieldName === 'matchingProduct') ? matchingWorkTitle : stateValue;
    }

    changeDataDisabled = () => {
    }

    keyDownSubmit = (value: any, fieldName: IRepertoireStateKeys) => {
        if (value.key === 'Enter') {
            this.onClickSearch();
        }
    }

    disabledSearchFields = (name: string) => {
        const fieldsToCheck = ["ipiNameNumber", "ipName", "productType", "customerAdvancedSearch", "venueAdvancedSearch", "artistAdvancedSearch"];
        if (fieldsToCheck.indexOf(name) == -1)
            return false;        

        // if any of other fields have value then disable the current field. (e.g productType has value then ipiNameNumber and ipName will be disabled)
        if (this.state[fieldsToCheck.filter(x => x !== name)[0]] || this.state[fieldsToCheck.filter(x => x !== name)[1]] || this.state[fieldsToCheck.filter(x => x !== name)[2]])
            return true;
    }

    onDistributionSelectionsChanged = (selectedKeys: string[]) => {
        this.setState(
            { distributionsFilter: selectedKeys },
            () => {
                this.props.searchDataChanged("distributionsFilter", this.state.distributionsFilter);
            }
        );
    };

    onPoolSelectionsChanged = (selectedKeys: string[]) => {
        this.setState(
            { poolsFilter: selectedKeys },
            () => {
                this.props.searchDataChanged("poolsFilter", this.state.poolsFilter);
            }
        );
    };

    onUsageGroupSelectionChanged = (usageGroupIds: string[], selected: boolean) => {

        if (this.bulkAdjustmentSubmissionInFlight) {
            return;
        }

        this.setState(previousState => {
            const nextSelectedIds = new Set(
                previousState.selectedUsageGroupIds
            );

            usageGroupIds.forEach(usageGroupId => {
                if (selected) {
                    nextSelectedIds.add(usageGroupId);
                } else {
                    nextSelectedIds.delete(usageGroupId);
                }
            });

            const selectedUsageGroupIds = Array.from(nextSelectedIds);

            const selectionIsEmpty = selectedUsageGroupIds.length === 0;

            return {
                selectedUsageGroupIds,
                bulkMatchPanelOpen: selectionIsEmpty ? false : previousState.bulkMatchPanelOpen,
                bulkMatchTarget: selectionIsEmpty ? null : previousState.bulkMatchTarget,
                bulkMatchSearchStarted: selectionIsEmpty ? false : previousState.bulkMatchSearchStarted,
                bulkAdjustmentPanelOpen: selectionIsEmpty ? false : previousState.bulkAdjustmentPanelOpen,
                bulkAdjustmentFromIP: selectionIsEmpty ? null : previousState.bulkAdjustmentFromIP,
                bulkAdjustmentToIP: selectionIsEmpty ? null : previousState.bulkAdjustmentToIP
            };
        });
    };

    openBulkMatchPanel = () => {
        if (this.props.canUpdateUsages !== true || this.state.selectedUsageGroupIds.length === 0 || this.state.bulkMatchPanelOpen || this.state.bulkAdjustmentPanelOpen) {
            return;
        }

        this.setState({
            bulkMatchPanelOpen: true,
            bulkMatchTarget: null,
            bulkMatchSearchStarted: false
        });
    };

    setHasOpenWorkFlow(option: string) {
        let openWorkflowsearch: boolean = null;

        if (option.length > 0)
            switch (option) {
                case DONOTCARE_ABOUTWORKFLOWS:
                    openWorkflowsearch = null;
                    break;
                case HASOPEN_WORKFLOWS:
                    openWorkflowsearch = true;
                    break;
                case WITHOUTOPEN_WORKFLOWS:
                    openWorkflowsearch = false;
                    break;
            }

        this.setState({ hasOpenWorkflow: openWorkflowsearch });
    }

    matchingWorkTitle = ''
    setMatchingWorkTitle = (title: string) => {
        this.matchingWorkTitle = title;
    }

    showSearchModal = () => {
        const { showModal, usageType } = this.props;
        showModal(USAGESEARCH_VIEW, usageType === 'Usage To Work' ? SEARCH_VIEW_USAGES_USAGE_TO_WORK : SEARCH_VIEW_USAGES_USAGE_TO_PRODUCT, { setTitle: this.setMatchingWorkTitle }, true, "Search");
    };

    showModalForUsageToProductAdvancedFields = (modalComponentInstance) => {
        const { showModal } = this.props;
        showModal(SEARCH_VIEW, modalComponentInstance, { isUsageSearchArtist: true }, true, "Search");
    }

    clearSearchField = (fieldName: string) => {
        if(fieldName === 'matchingWork' || fieldName === 'matchingProduct') {
            this.matchingWorkTitle = '';
        }
        this.changeData('', fieldName);
    };

    onSearchPools = (poolCodeToSearch: string) => {
        const { searchUsagePoolsByCodeDistributionPools, updatePoolCodeToSearch } = this.props;

        updatePoolCodeToSearch(poolCodeToSearch);

        if (poolCodeToSearch && poolCodeToSearch.length >= 5) {
            const searchQuery: IUsagePoolSearchQuery = {
                poolCode: poolCodeToSearch,
                cat1: EMPTY_STRING_VALUE,
                cat2: EMPTY_STRING_VALUE,
                allocationRule: EMPTY_STRING_VALUE,
                pagination: {
                    count: 150,
                    skip: 0,
                    orderBy: "poolCode",
                },
            };
            searchUsagePoolsByCodeDistributionPools(searchQuery);
        }
    }

    onSearchDistributions = (distributionCodeToSearch: string) => {
        const { searchDistributionByCode, updateDistributionCodeToSearch } = this.props;

        updateDistributionCodeToSearch(distributionCodeToSearch)

        if (distributionCodeToSearch && distributionCodeToSearch.length >= 5) {
            const searchQuery: IDistributionSearchQuery = {
                year: EMPTY_STRING_VALUE,
                distributionCode: distributionCodeToSearch,
                distributionType: EMPTY_STRING_VALUE,
                distributionStatus: EMPTY_STRING_VALUE,
                cat1: EMPTY_STRING_VALUE,
                cat2: EMPTY_STRING_VALUE,
                description: EMPTY_STRING_VALUE,
                pagination: {
                    count: 150,
                    skip: 0,
                    orderBy: "distributionCode",
                },
                isBackendSearch: true,
            };

            searchDistributionByCode(searchQuery);
        }
    }

    renderSearchFields = (typeOfSearch?: string) => {
        const { 
            searchViewData,
            lookupValues,
            distributions,
            pools,
            sourceMinors,
            sourceMajors,
            usageType,
            lookupSources,
            distributionTypes,
            usageGroup,
            expanderFieldsData,
            customer,
            usageDistributionsSearchResults,
            usagePoolsSearchResults,
            componentInstance
        } = this.props;

        const { type } = this.state;

        const distributionCodeCalculationRule =
            (distributionTypes ?? []).find(distributionType => distributionType.description === type)?.codeCalculationRule;

        const distributionPrefix = distributionCodeCalculationRule ? JSON.parse(distributionCodeCalculationRule).Prefix?.[0] : undefined;

        const distributionOptions =
            this.getDistributionOptions(
                distributions,
                usageDistributionsSearchResults,
                distributionPrefix,
                this.state.distributionsFilter
            );

        const poolOptions =
            this.getPoolOptions(
                pools,
                usagePoolsSearchResults,
                this.state.poolsFilter
            );

        let componentInstanceForFields;

        if (componentInstance === SEARCH_VIEW_USAGES) {
            componentInstanceForFields = SEARCH_VIEW_USAGES + usageType.replace(/\s+/g, '');
        }
        else if (componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY) {
            componentInstanceForFields = USAGE_MATCHING_WORKS_SECTION_KEY;
        }
         else if (componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY) {
            componentInstanceForFields = USAGE_MATCHING_PRODUCTS_SECTION_KEY;
        }
        
        if (searchViewData && searchViewData.fields) {
            let filteredSearchFields = searchViewData.fields.filter(
                (searchField: IRepertoireField) =>
                    searchField.componentInstance === componentInstanceForFields
            );

            if (typeOfSearch === ADVANCED) {
                filteredSearchFields = filteredSearchFields.filter(x => !x.hidden && x.section === 'advanced');
            }
            else {
                filteredSearchFields = filteredSearchFields.filter(x => !x.hidden && x.section !== 'advanced');
            }

            //if productType is SETLIST, add venueName, customer, artistAdvancedSearch, licensingSystemID fields for advanced search
            const productTypeField = filteredSearchFields.find(f => f.name === 'productType');
            if (productTypeField && this.state['productType'] !== 'SET LIST') {
                filteredSearchFields = filteredSearchFields.filter(f => f.name !== 'venueAdvancedSearch' && f.name !== 'customerAdvancedSearch' && f.name !== 'artistAdvancedSearch' && f.name !== 'licensingSystemID');
            }

            var filteredSearchFieldsMapper = (searchField: IRepertoireField, index: number): ReactElement => {
                let reactElement: ReactElement = <></>;

                //condition to check if field is matching work/product textbox or not
                let condition = componentInstance === SEARCH_VIEW_USAGES && searchField.name === 'matchingWork' || searchField.name === 'matchingProduct';
                let conditionAdvancedSearch = componentInstance === SEARCH_VIEW_USAGES && (searchField.name === 'customerAdvancedSearch' || searchField.name === 'artistAdvancedSearch' || searchField.name === 'venueAdvancedSearch');
                condition = condition || conditionAdvancedSearch;
                let InlineActionButtonWrapper: IInlineActionButtonWrapper = condition ? {
                    wrapperClassName: "matchingButtonWrapper",
                    buttonAction: (() => {
                        this.clearSearchField(searchField.name)
                        this.setState({ matchID: null });
                    }),
                    buttonText: "Clear",
                    buttonClassName: "button"
                } : undefined;

                if(searchField.name === "productType" && componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY) return <></>;

                if (searchField.fieldType === 'text' || searchField.fieldType === 'integer' || searchField.fieldType === 'decimal' || searchField.fieldType === 'readonly' || searchField.fieldType === 'textWithSearchType')                
                    reactElement =
                        <InputWithKebabMenu
                            key={index}
                            variant="form"
                            className={USAGE_PAGE_FORM_ITEM_SIZE}
                            kebab={condition ? (
                                <ShowMore
                                    options={(() => {
                                        if (searchField.name === 'matchingWork') {
                                            return [{
                                                text: expanderFieldsData ? expanderFieldsData.find(e => e.name === "selectWork")?.data : '',
                                                onClick: () => { this.showSearchModal(); },
                                                icon: EXTERNAL_SVG
                                            }];
                                        } else if (searchField.name === 'matchingProduct') {
                                            return [{
                                                text: expanderFieldsData ? expanderFieldsData.find(e => e.name === "selectProduct")?.data : '',
                                                onClick: () => { this.showSearchModal(); },
                                                icon: EXTERNAL_SVG
                                            }];
                                        } else if (searchField.name === 'customerAdvancedSearch') {
                                            return [{
                                                text: expanderFieldsData ? expanderFieldsData.find(e => e.name === "selectCustomer")?.data : '',
                                                onClick: () => { this.showModalForUsageToProductAdvancedFields(SEARCH_VIEW_VENUES); },
                                                icon: EXTERNAL_SVG
                                            }];
                                        } else if (searchField.name === 'artistAdvancedSearch') {
                                            return [{
                                                text: expanderFieldsData ? expanderFieldsData.find(e => e.name === "selectArtist")?.data : '',
                                                onClick: () => { this.showModalForUsageToProductAdvancedFields(SEARCH_VIEW_ARTISTS); },
                                                icon: EXTERNAL_SVG
                                            }];
                                        } else if (searchField.name === 'venueAdvancedSearch') {
                                            return [{
                                                text: expanderFieldsData ? expanderFieldsData.find(e => e.name === "selectVenue")?.data : '',
                                                onClick: () => { this.showModalForUsageToProductAdvancedFields(SEARCH_VIEW_LICENSE_VENUES); },
                                                icon: EXTERNAL_SVG
                                            }];
                                        }
                                        return [];
                                    })()}
                                />
                            ) : null}
                        >
                            <TextDataInput
                                fieldType={searchField.fieldType}
                                useEnterSubmit={true}
                                label={searchField.data}
                                fieldName={searchField.name}
                                changeData={(value, fieldName) => this.handleMatchingWorkOrProductChange(value, fieldName)}
                                handleKeyDown={this.keyDownSubmit}
                                value={this.getMatchingWorkOrProductValue(searchField.name, condition, this.matchingWorkTitle, this.state[searchField.name])}
                                readOnly={this.disabledSearchFields(searchField.name)}
                                isHidden={searchField.hidden}
                                InlineActionButtonWrapper={InlineActionButtonWrapper}
                            />
                        </InputWithKebabMenu>       
                else if (searchField.fieldType === 'date')
                    reactElement =
                        <SizedDateDataInput
                        key={index}
                        label={searchField.data}
                        fieldName={searchField.name}
                        changeData={this.changeData}
                        value={this.state[searchField.name]}
                        isHidden={searchField.hidden}
                        showTime={true}
                        isMandatory={isMandatoryField(searchField)}
                        />
                else if (searchField.name === SOURCEMAJOR_SEARCH_USAGES_STATE_KEY)
                    reactElement =
                        <SizedDropdownTreeDataInput
                            key={index}
                            label={searchField.data}
                            fieldName={searchField.name}
                            changeData={this.changeData}
                            value={this.state[searchField.name]}
                            options={lookupSources ? lookupSources : undefined}
                            allowNull={true}
                            isHidden={searchField.hidden}
                            componentInstance={componentInstance}
                            isMandatory={isMandatoryField(searchField)}
                            showSearch={true}
                        />
                else if (searchField.fieldType === 'boolean' && searchField.name === SEARCH_VIEW_HAS_OPEN_WORKFLOW)
                    reactElement =
                        <div key={index}>
                            <SizedRadiobuttonDataInput
                                selectedValue={this.state[searchField.name] === null ?
                                    DONOTCARE_ABOUTWORKFLOWS :
                                    this.state[searchField.name] === true ? HASOPEN_WORKFLOWS : WITHOUTOPEN_WORKFLOWS}
                                onSelectionChange={this.setHasOpenWorkFlow.bind(this)}
                                radioName="hasOpenWorkFlow"
                                title={searchField.data}
                                options={[
                                    { desc: ComponentsHelper.getFieldValueByName("doNotCareAboutWorkflowsDesc", searchViewData.fields), code: DONOTCARE_ABOUTWORKFLOWS },
                                    { desc: ComponentsHelper.getFieldValueByName("hasOpenWorkflowsDesc", searchViewData.fields), code: HASOPEN_WORKFLOWS },
                                    { desc: ComponentsHelper.getFieldValueByName("withoutOpenWorkflowsDesc", searchViewData.fields), code: WITHOUTOPEN_WORKFLOWS }
                                ]}
                            />
                        </div>
                else if (componentInstance === SEARCH_VIEW_USAGES && searchField.name === DISTRIBUTION_SEARCH_USAGES_STATE_KEY) {
                    reactElement = searchField.hidden
                        ? null
                        : (
                            <div key={index} className={USAGE_PAGE_FORM_ITEM_SIZE}>
                                <div className="dropdownDataInput">
                                    <SearchableMultiSelectComboBox
                                        label={searchField.data}
                                        options={distributionOptions}
                                        selectedKeys={this.state.distributionsFilter}
                                        onSelectionChange={this.onDistributionSelectionsChanged}
                                        onSearch={this.onSearchDistributions}
                                        searchPlaceholder="Search distributions"
                                        noResultsText="No distributions found"
                                        required={isMandatoryField(searchField)}
                                        minimumBackendSearchLength={5}
                                        debounceMs={400}
                                    />
                                </div>
                            </div>
                        );
                }
                else if (componentInstance === SEARCH_VIEW_USAGES && searchField.name === POOL_SEARCH_USAGES_STATE_KEY) {
                    reactElement = searchField.hidden
                        ? null
                        : (
                            <div key={index} className={USAGE_PAGE_FORM_ITEM_SIZE}>
                                <div className="dropdownDataInput">
                                    <SearchableMultiSelectComboBox
                                        label={searchField.data}
                                        options={poolOptions}
                                        selectedKeys={this.state.poolsFilter}
                                        onSelectionChange={this.onPoolSelectionsChanged}
                                        onSearch={this.onSearchPools}
                                        searchPlaceholder="Search pools"
                                        noResultsText="No pools found"
                                        required={isMandatoryField(searchField)}
                                        minimumBackendSearchLength={5}
                                        debounceMs={400}
                                    />
                                </div>
                            </div>
                        );
                }
                else {
                    let options: { code: string, description: string }[] = [];
                    if (componentInstance === SEARCH_VIEW_USAGES && searchField.name === PAYMENTRUN_DISTRIBUTION_CODE_STATE_KEY) {
                        if (usageDistributionsSearchResults) {
                            options = usageDistributionsSearchResults.map((x) => ({
                                code: x.distributionCode,
                                description: x.description ? x.description : x.distributionCode
                            }));
                        }
                        else if (distributions)
                            distributions.map((x) => ({ code: x.code, description: x.description ? x.description : x.code }));
                    }
                    else if (componentInstance === SEARCH_VIEW_USAGES && searchField.name === SOURCEMAJOR_SEARCH_USAGES_STATE_KEY)
                        options = sourceMajors;
                    else if (componentInstance === SEARCH_VIEW_USAGES && searchField.name === SOURCEMINOR_SEARCH_USAGES_STATE_KEY)
                        options = sourceMinors;
                    else if (componentInstance === SEARCH_VIEW_USAGES && searchField.name === USAGETYPE_SEARCH_USAGES_STATE_KEY) {
                        if (distributionTypes) options = distributionTypes.map((x): any => Object.assign(x, { code: x.description, description: x.description }));
                    }
                    else if (componentInstance === SEARCH_VIEW_USAGES && searchField.name === USAGE_GROUP_MATCH_STATUS_STATE_KEY) {
                        options = getLookupValues(mapUsageLookupKey(searchField.name, ''), lookupValues).map((x): any => Object.assign(x, { code: x.description, description: x.description, extraFields: { DisabledInDropdown: false } }));
                    }
                    else if (lookupValues && (componentInstance === SEARCH_VIEW_PRODUCTS || componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY) && searchField.name === "status")
                                            options = getLookupValues(PRODUCT_STATUS_TYPE_LOOKUP, lookupValues)
                    else if (lookupValues && (componentInstance === SEARCH_VIEW_PRODUCTS || componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY) && searchField.name === "source") {
                                            options = getLookupValues(PRODUCT_SOURCE_LOOKUP, lookupValues)
                    }
                    else if (lookupValues && getLookupValues(mapUsageLookupKey(searchField.name, ''), lookupValues)) {
                        options = getLookupValues(mapUsageLookupKey(searchField.name, ''), lookupValues);
                    }
                    else
                        options = undefined;

                    reactElement =
                        <div key={index}>
                            <InputSizedDropdown
                                label={searchField.data}
                                fieldName={searchField.name}
                                changeData={this.changeData}
                                value={this.state[searchField.name]}
                                options={options}
                                allowNull={true}
                                isHidden={searchField.hidden}
                                componentInstance={componentInstance}
                                backendSearch={customer === 'CEDRO' ? true : false}
                                onBackendSearch={searchField.name === POOL_SEARCH_USAGES_STATE_KEY ? this.onSearchPools.bind(this) : this.onSearchDistributions.bind(this)}
                                isMandatory={isMandatoryField(searchField)}
                            />
                        </div>
                }

                return reactElement;
            }

            return filteredSearchFields.map(filteredSearchFieldsMapper);
        }
    };

    onClickSearch = (continuationToken?: string, pageSize?: number, pageNumber?:number, itemsPerPage?: number) => {
        if (this.bulkAdjustmentSubmissionInFlight) {
            return;
        }

        const {
            type,
            distributionsFilter,
            poolsFilter,
            fileName,
            title,
            composer,
            sourceMajor,
            rightShareOwner,
            allocationStatus,
            includeFeesInError,
            licenseesWorkNumber,
            matchStatus,
            setPageOne,
            number,
            writers,
            societyAccountNumber,
            workBatchID,
            dataSource,
            artist,
            hasOpenWorkflow,
            productBatchID,
            contributor,
            productType,
            matchID,
            titleContains,
            sourcesFilter,
            approvalStatus,
            qaStatus,
            weight,
            estimatedValue,
            estimatedFromValue,
            estimatedToValue,
            performanceNumberType,
            performanceNumber,
            fromDate,
            toDate,
            usageUse,
            programName,
            carrierType,
            dimension1,
            dimension2,
            dimension3,
            dimension4,
            dimension5,
            venueName,
            ipName,
            ipiNameNumber,
            licensingSystemID,
            artistAdvancedSearch,
            customerCodeAdvancedSearch,
            venueCodeAdvancedSearch,
            source,
            status,
        } = this.state;
        const {
            componentInstance,
            searchUsages,
            resetPagination,
            usageType,
            searchSource = USAGE_SEARCH_SOURCE_COSMOS,
            lookupSources,
            searchMatchWorks,
            searchMatchProducts,
            usageGroup,
            updateAdjustmentField,
            adjustment,
            workAdjustmentIndex,
            lookupValues,
            externalLinks
        } = this.props;

        const isNewUsageSearch = componentInstance === SEARCH_VIEW_USAGES && !continuationToken;

        if (!continuationToken) {
            resetPagination(componentInstance);
        }
        
        this.setState(previousState => ({
            setPageOne: previousState.setPageOne + 1,
            isLoading: true,
            selectedUsageGroupIds: isNewUsageSearch ? [] : previousState.selectedUsageGroupIds,
            bulkMatchPanelOpen: isNewUsageSearch ? false : previousState.bulkMatchPanelOpen,
            bulkMatchTarget: isNewUsageSearch ? null : previousState.bulkMatchTarget,
            bulkAdjustmentPanelOpen: isNewUsageSearch ? false : previousState.bulkAdjustmentPanelOpen,
            bulkAdjustmentFromIP: isNewUsageSearch ? null : previousState.bulkAdjustmentFromIP,
            bulkAdjustmentToIP: isNewUsageSearch ? null : previousState.bulkAdjustmentToIP,
        }));

        switch (componentInstance) {
            case SEARCH_VIEW_USAGES: {

                let sourceMaj = '';
                let sourceMin = '';
                if (sourceMajor) {
					const selectedSource = lookupSources.find(source => source.id === sourceMajor);

					if (selectedSource) {
						const hasChildren = lookupSources.some(source => source.pId === selectedSource.id);
						const hierarchy = hasChildren 
							? selectedSource.hierarchy.replace("Global/", "") 
							: selectedSource.hierarchy;
                        const splitString = hierarchy.split("/").reverse();

                        if (splitString.length >= 2) {
                            sourceMin = splitString[0];
                            sourceMaj = splitString[1];
                        } else {
                            sourceMaj = splitString[0];
                        }
                    }
                }

                const searchQuery: IUsagesSearchQuery = {
                    usageType,
                    searchSource,
                    type,
                    distributionsFilter,
                    poolsFilter,
                    fileName,
                    title,
                    composer,
                    artist,
                    sourceMajor: sourceMaj,
                    sourceMinor: sourceMin,
                    rightShareOwner,
                    allocationStatus,
                    includeFeesInError,
                    totalWeight: weight,
                    licenseesWorkNumber,
                    matchStatus,
                    hasOpenWorkflow,
                    matchID,
                    titleContains,
                    sourcesFilter,
                    approvalStatus,
                    qaStatus,
                    estimatedValue,
                    estimatedFromValue,
                    estimatedToValue,
                    productType,
                    performanceNumberType,
                    performanceNumber,
                    fromDate,
                    toDate,
                    usageUse,
                    programName,
                    carrierType,
                    dimension1,
                    dimension2,
                    dimension3,
                    dimension4,
                    dimension5,
                    venueName,
                    ipName,
                    ipiNameNumber,
                    pageSize,
                    pageNumber,
                    itemsPerPage,
                    licensingSystemID,
                    artistNameAdvancedSearch: artistAdvancedSearch,
                    customerCodeAdvancedSearch: customerCodeAdvancedSearch,
                    venueCodeAdvancedSearch: venueCodeAdvancedSearch
                };

                searchUsages(searchQuery, true, usageType, lookupSources, continuationToken || null, pageNumber ? externalLinks : null);
                break;
            }
            case SEARCH_VIEW_USAGES_USAGE_TO_WORK:
            case USAGE_MATCHING_WORKS_SECTION_KEY: {
                if (adjustment && updateAdjustmentField) {
                    let updatedAdjustment = adjustment;
                    updatedAdjustment.workSearchIndex = workAdjustmentIndex;
                    updateAdjustmentField(workAdjustmentIndex, 'workSearchIndex')
                }

                let searchQuery: IMatchWorksSearchQuery = {
                    workIDs: [],
                    title,
                    number,
                    artist,
                    writers,
                    societyAccountNumber,
                    workBatchID,
                    dataSource,
                    hasOpenWorkflow
                };
                searchMatchWorks(searchQuery, false, lookupValues);
                break;
            }
            case SEARCH_VIEW_USAGES_USAGE_TO_PRODUCT: 
            case USAGE_MATCHING_PRODUCTS_SECTION_KEY: {  
                let searchQuery: IMatchProductsSearchQuery = {
                    title,
                    number,
                    artist,
                    productBatchID,
                    contributor,
                    dataSource,
                    productIDs: [],
                    source,      
                    status,
                    productType: usageGroup && usageGroup.usageType === USAGETOPRODUCT_NO_SPACES && usageGroup.productType ? usageGroup.productType : productType
                };
                searchMatchProducts(searchQuery, false);
                break;
            }
            default: {
                return;
            }
        }
    };

    selectBulkWorkTarget = (work: IMatchWorksSearchResult) => {
        this.setState({
            bulkMatchTarget: mapWorkToBulkMatchTarget(work)
        });
    };

    selectBulkProductTarget = (product: IProductSearchResult) => {
        this.setState({
            bulkMatchTarget: mapProductToBulkMatchTarget(product)
        });
    };

    closeBulkMatchPanel = () => {
        if (this.state.bulkMatchSubmitting) {
            return;
        }

        this.setState({
            bulkMatchPanelOpen: false,
            bulkMatchTarget: null,
            bulkMatchSearchStarted: false
        });
    };

    onBulkTargetSelected = (selectedResult: UsageBulkMatchSearchResult) => {
        if (this.props.usageType === USAGETOWORK) {
            this.selectBulkWorkTarget(selectedResult as IMatchWorksSearchResult);
            return;
        }

        if (this.props.usageType === USAGETOPRODUCT) {
            this.selectBulkProductTarget(selectedResult as IProductSearchResult);
        }
    };

    openBulkMatchTarget = (target: IBulkMatchTarget): void => {
        const { getWorkDetails, getProductDetails } = this.props;

        if (target.entityType === "Work") {
            getWorkDetails?.({
                workID: target.matchID,
                dataSource: target.dataSource
            });

            return;
        }

        getProductDetails?.(
            { productCoreID: target.matchID, dataSource: target.dataSource },
            undefined,
            true
        );
    };
    
    removeBulkMatchTarget = () => {
        this.setState({
            bulkMatchTarget: null
        });
    };

    onBulkMatchSave = async (createMatchHistory: boolean): Promise<void> => {
        const { selectedUsageGroupIds, bulkMatchTarget, bulkMatchSubmitting} = this.state;

        const { usageType, submitBulkMatch, canUpdateUsages, usageGroupsSearchResult } = this.props;

        if (canUpdateUsages !== true || this.bulkMatchSubmissionInFlight || bulkMatchSubmitting || !submitBulkMatch) {
            return;
        }

        const request =
            buildBulkMatchRequest(usageType, selectedUsageGroupIds, usageGroupsSearchResult, bulkMatchTarget, createMatchHistory);

        if (request === null) {
            return;
        }
        
        this.bulkMatchSubmissionInFlight = true;
        this.setState({ bulkMatchSubmitting: true });

        try {
            await submitBulkMatch(request);

            this.setState({
                selectedUsageGroupIds: [],
                bulkMatchPanelOpen: false,
                bulkMatchTarget: null,
                bulkMatchSearchStarted: false
            });
        }
        catch {
        }
        finally {
            this.bulkMatchSubmissionInFlight = false;
            this.setState({ bulkMatchSubmitting: false });
        }
    };

    resetBulkTargetPagination = (_repertoireSection: string): void => {};

    updateBulkTargetPagination = (
        _indexOfFirstResult: number,
        _indexOfLastResult: number,
        _resultsPerPage: number,
        _currentPage: number,
        _repertoireSection: string
    ): void => {};

    searchBulkMatchWorks = (query: IMatchWorksSearchQuery, modalOpen: boolean, lookupValues?: ILookupDictionary): void => {
        this.setState(
            { bulkMatchSearchStarted: false },
            () => {
                this.props.searchMatchWorks?.(
                    query,
                    modalOpen,
                    lookupValues
                );
            }
        );
    };

    searchBulkMatchProducts = (query: IMatchProductsSearchQuery, modalOpen: boolean): void => {
        this.setState(
            { bulkMatchSearchStarted: false },
            () => {
                this.props.searchMatchProducts?.(
                    query,
                    modalOpen
                );
            }
        );
    };

    renderBulkMatchPanel = () => {
        const { bulkMatchPanelOpen, bulkMatchTarget, bulkMatchSubmitting, bulkMatchSearchStarted, selectedUsageGroupIds } = this.state;

        if (!bulkMatchPanelOpen) {
            return null;
        }

        const {
            usageType,
            searchViewData,
            bulkTargetSearchViewData,
            searchResultsTableData,
            searchSuccessful,
            searchUsages,
            searchMatchWorks,
            searchMatchProducts,
            matchWorkSearchResult,
            matchProductsSearchResult,
            getUsageDetails,
            hideModal,
            expandMatchWorkResult,
            expandedMatchWorkResults,
            usageExpandAll,
            usageExpandAllResults,
            searchDataChanged,
            lookupValues,
            lookupSources,
            distributionTypes,
            sortSearchResults,
            getWorkDetails,
            getProductDetails
        } = this.props;

        const targetSearchComponent = usageType === USAGETOWORK ? USAGE_MATCHING_WORKS_SECTION_KEY : USAGE_MATCHING_PRODUCTS_SECTION_KEY;

        const targetSearchViewData = usageType === USAGETOPRODUCT ? bulkTargetSearchViewData : searchViewData;

        const initialSearchValues = deriveBulkTargetSearchDefaults(
                this.props.usageGroupsSearchResult,
                selectedUsageGroupIds,
                usageType
            );

        const selectedUsageGroupsKey = [...selectedUsageGroupIds].sort().join("|");

        const candidateSearch =
            bulkMatchTarget === null
                ? (
                    <UsageSearchView
                        key={`bulk-target-${usageType}-${selectedUsageGroupsKey}`}
                        initialSearchValues={initialSearchValues}
                        searchViewData={
                            targetSearchViewData ?? {
                                fields: []
                            }
                        }
                        searchResultsTableData={searchResultsTableData}
                        searchSuccessful={searchSuccessful}
                        componentInstance={targetSearchComponent}
                        modalProps={undefined}
                        onSelectResult={this.onBulkTargetSelected}
                        searchUsages={searchUsages}
                        searchMatchWorks={this.searchBulkMatchWorks}
                        searchMatchProducts={this.searchBulkMatchProducts}
                        matchWorkSearchResult={bulkMatchSearchStarted ? matchWorkSearchResult : undefined}
                        matchProductsSearchResult={bulkMatchSearchStarted ? matchProductsSearchResult : undefined}
                        canUpdateUsages={this.props.canUpdateUsages}
                        resetPagination={this.resetBulkTargetPagination}
                        updatePagination={this.updateBulkTargetPagination}
                        getUsageDetails={getUsageDetails}
                        hideModal={hideModal}
                        expandMatchWorkResult={expandMatchWorkResult}
                        expandedMatchWorkResults={expandedMatchWorkResults}
                        usageExpandAll={usageExpandAll}
                        usageExpandAllResults={usageExpandAllResults}
                        searchDataChanged={searchDataChanged}
                        lookupValues={lookupValues}
                        lookupSources={lookupSources}
                        distributionTypes={distributionTypes}
                        sortSearchResults={sortSearchResults}
                        getWorkDetails={getWorkDetails}
                        getProductDetails={getProductDetails}
                    />
                ) : null;

        const ariaLabel = usageType === USAGETOWORK ? "Search Work to Match" : "Search Product to Match";

        return (
            <UsageBulkMatchPanel
                ariaLabel={ariaLabel}
                target={bulkMatchTarget}
                submitting={bulkMatchSubmitting}
                onOpenTarget={this.openBulkMatchTarget}
                onRemoveTarget={this.removeBulkMatchTarget}
                onApply={this.onBulkMatchSave}
                onCancel={this.closeBulkMatchPanel}
            >
                {candidateSearch}
            </UsageBulkMatchPanel>
        );
    };

    openBulkAdjustmentIPSearch = (side: "from" | "to"): void => {
        const { showModal, canBulkAdjust } = this.props;

        if (!showModal || canBulkAdjust !== true || !this.state.bulkAdjustmentPanelOpen || this.bulkAdjustmentSubmissionInFlight) {
            return;
        }

        showModal(
            SEARCH_VIEW,
            USAGE_DETAILS_ROWS_SECTION_KEY,
            {
                onSelectBulkAdjustmentIP: (ip: IP): void => {
                    if (!this.state.bulkAdjustmentPanelOpen || this.bulkAdjustmentSubmissionInFlight) {
                        return;
                    }

                    const selectedIP: IBulkUsageIpAdjustmentIP = {
                        ipiNumber: Number(ip.ipiNumber),
                        name: ip.ipName?.trim() ?? "",
                        accountNumber: ip.accountNumber?.trim() ?? ""
                    };

                    if (side === "from") {
                        this.setBulkAdjustmentFromIP(selectedIP);
                    } else {
                        this.setBulkAdjustmentToIP(selectedIP);
                    }
                }
            },
            true,
            side === "from" ? "Search From IP" : "Search To IP"
        );
    };

    setBulkAdjustmentFromIP = (ip: IBulkUsageIpAdjustmentIP | null): void => {
        if (this.bulkAdjustmentSubmissionInFlight) return;
        this.setState({ bulkAdjustmentFromIP: ip });
    };

    setBulkAdjustmentToIP = (ip: IBulkUsageIpAdjustmentIP | null): void => {
        if (this.bulkAdjustmentSubmissionInFlight) return;
        this.setState({ bulkAdjustmentToIP: ip });
    };

    openBulkAdjustmentPanel = () => {
        if (
            this.props.canBulkAdjust !== true ||
            this.state.selectedUsageGroupIds.length === 0 ||
            this.state.bulkMatchPanelOpen ||
            this.state.bulkAdjustmentPanelOpen
        ) {
            return;
        }

        this.setState({ bulkAdjustmentPanelOpen: true });
    };

    closeBulkAdjustmentPanel = () => {
        if (this.bulkAdjustmentSubmissionInFlight) return;
        this.setState({
            bulkAdjustmentPanelOpen: false,
            bulkAdjustmentFromIP: null,
            bulkAdjustmentToIP: null
        });
    };

    openBulkAdjustmentConfirmation = (
        fromIP: IBulkUsageIpAdjustmentIP,
        toIP: IBulkUsageIpAdjustmentIP
    ): void => {
        const { showModal, hideModal } = this.props;

        if (!showModal || !this.state.bulkAdjustmentPanelOpen || this.bulkAdjustmentSubmissionInFlight) {
            return;
        }

        showModal(
            BULK_USAGE_IP_ADJUSTMENT_CONFIRM_VIEW,
            null,
            {
                selectedGroupCount: this.state.selectedUsageGroupIds.length,
                fromIP,
                toIP,
                onCancel: hideModal,
                onConfirm: () => {
                    hideModal();
                    void this.submitBulkAdjustment(fromIP, toIP);
                }
            },
            true,
            "Confirm Bulk Usage IP Adjustment"
        );
    };

    submitBulkAdjustment = async (fromIP: IBulkUsageIpAdjustmentIP, toIP: IBulkUsageIpAdjustmentIP): Promise<void> => {
        if (
            this.bulkAdjustmentSubmissionInFlight ||
            this.props.canBulkAdjust !== true ||
            !this.props.submitBulkAdjustment ||
            this.state.selectedUsageGroupIds.length === 0 ||
            fromIP.ipiNumber <= 0 ||
            toIP.ipiNumber <= 0 ||
            fromIP.ipiNumber === toIP.ipiNumber ||
            !fromIP.name.trim() ||
            !toIP.name.trim()
        ) {
            return;
        }
        
        const request: IBulkUsageIpAdjustmentRequest = {
            usageGroupIDs: Array.from(new Set(this.state.selectedUsageGroupIds)),
            fromIP,
            toIP
        };

        this.bulkAdjustmentSubmissionInFlight = true;
        this.setState({ bulkAdjustmentSubmitting: true });

        try {
            await this.props.submitBulkAdjustment(request);

            this.setState({
                selectedUsageGroupIds: [],
                bulkAdjustmentPanelOpen: false,
                bulkAdjustmentFromIP: null,
                bulkAdjustmentToIP: null
            });
        }
        catch {
            // The thunk displays the API error. Keep the panel and selection.
        }
        finally {
            this.bulkAdjustmentSubmissionInFlight = false;
            this.setState({ bulkAdjustmentSubmitting: false });
        }
    };

    renderBulkAdjustmentPanel = () => {
        if (!this.state.bulkAdjustmentPanelOpen) return null;

        return (
            <UsageBulkAdjustmentPanel
                selectedGroupCount={this.state.selectedUsageGroupIds.length}
                submitting={this.state.bulkAdjustmentSubmitting}
                fromIP={this.state.bulkAdjustmentFromIP}
                toIP={this.state.bulkAdjustmentToIP}
                onSearchFromIP={() => this.openBulkAdjustmentIPSearch("from")}
                onSearchToIP={() => this.openBulkAdjustmentIPSearch("to")}
                onApply={this.openBulkAdjustmentConfirmation}
                onCancel={this.closeBulkAdjustmentPanel}
            />
        );
    };

    renderSearchResults() {
        const {
            searchResultsTableData,
            componentInstance,
            usageGroupsSearchResult,
            matchWorkSearchResult,
            matchProductsSearchResult,
            modalProps,
            searchSuccessful,
            indexOfFirstResult,
            indexOfLastResult,
            resultsPerPage,
            currentPage,
            updatePagination,
            getUsageDetails,
            getDistributionDetails,
            getUsagePool,
            expandMatchWorkResult,
            expandedMatchWorkResults,
            usageExpandAll,
            usageExpandAllResults,
            addMatchworkToUsage,
            hideModal,
            usageType,
            searchSource = USAGE_SEARCH_SOURCE_COSMOS,
            onClickNumber,
            addMatchProductToUsage,
            onlySearchResults,
            lookupSources,
            lookupValues,
            searchUsages,
            sortSearchResults,
            distributions,
            pools,
            continuationToken,
            showFieldsModal,
            updateUsageGroupMatches,
            saveUsageGroup,
            saveResultData,
            addWorkOrProductToUsageSearchCriteria,
            isHundredResultsPerPage,
            setIsHundredResultsPerPage,
            matchingSources,
            getWorkDetails,
            adjustmentDetails,
            adjustment,
            workAdjustmentIndex,
            usageSearchResultConfiguration,
            settingsModalViewData,
            componentViews,
            enabledAdjustmentICEWorkSearch,
            showModal,
            allocationRecords,
            setActiveComponentView,
            usageSearchResultsActiveComponentView,
            userIsConfigureComponentViewAdmin,
            componentViewPreference,
            getProductDetails,
            usageNumberInSearchExclude
        } = this.props;

        const { setPageOne, titleContains, isLoading } = this.state;
        if (isLoading) {
            return (<div className="loaderWrapper">
                <div className="spinner-dualball">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>)
        }
        else if (usageGroupsSearchResult || matchWorkSearchResult || matchProductsSearchResult) {
            if (onlySearchResults && usageGroupsSearchResult === undefined) {
                const searchQuery: IUsagesSearchQuery = {
                    usageType: USAGETOWORK,
                    searchSource,
                    type: "",
                    distributionsFilter: [],
                    poolsFilter: [],
                    fileName: "",
                    title: "",
                    composer: "",
                    artist: "",
                    sourceMajor: "",
                    sourceMinor: "",
                    rightShareOwner: "",
                    allocationStatus: "",
                    includeFeesInError: "",
                    totalWeight: "",
                    licenseesWorkNumber: "",
                    matchStatus: "",
                    hasOpenWorkflow: null,
                    matchID: modalProps,
                    estimatedValue: 0,
                    estimatedFromValue: "",
                    estimatedToValue: "",
                    productType: "",
                    performanceNumberType: "",
                    performanceNumber: "",
                    fromDate: null,
                    toDate: null,
                    usageUse: "",
                    programName: "",
                    carrierType: "",
                    dimension1: "",
                    dimension2: "",
                    dimension3: "",
                    dimension4: "",
                    dimension5: "",
                    venueName: "",
                    ipName: "",
                    ipiNameNumber : "",
                    licensingSystemID: "",
                    artistNameAdvancedSearch: "",
                    customerCodeAdvancedSearch: "",
                    venueCodeAdvancedSearch: "",
                    pageSize: this.state.pageSize
                };

                searchUsages(searchQuery, true, USAGETOWORK, lookupSources);
            }

            if (searchSuccessful && onlySearchResults && (!!usageGroupsSearchResult && usageGroupsSearchResult.length <= 0)) {
                return (
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 centerTextNotFound" >
                            No usages found.
                        </div>
                    </div>
                )
            }

            const currentComponentHasNoResults =
                componentInstance === SEARCH_VIEW_USAGES
                    ? Array.isArray(usageGroupsSearchResult) &&
                    usageGroupsSearchResult.length === 0
                    : componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY
                        ? Array.isArray(matchWorkSearchResult) &&
                        matchWorkSearchResult.length === 0
                        : componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY
                            ? Array.isArray(matchProductsSearchResult) &&
                            matchProductsSearchResult.length === 0
                            : false;

            if (searchSuccessful && !onlySearchResults && currentComponentHasNoResults) {
                const noResultsMessage =
                    componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY
                        ? "No Works found. Update the search criteria and search again."
                        : componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY
                            ? "No Products found. Update the search criteria and search again."
                            : "No results found.";

                return (
                    <div className="row">
                        <div className="col-md-12 centerTextNotFound">
                            {noResultsMessage}
                        </div>
                    </div>
                );
            }
            else if (componentInstance === SEARCH_VIEW_USAGES &&
                usageGroupsSearchResult && usageGroupsSearchResult.length >= 1) {

                const bulkActionPanelOpen = this.state.bulkMatchPanelOpen || this.state.bulkAdjustmentPanelOpen;

                return (<div className="row">
                    <div className={`col-md-12 searchResultsDiv${bulkActionPanelOpen ? ' bulkUsageSearchResultsLayout' : ''}`}>
                        {this.renderBulkMatchPanel()}
                        {this.renderBulkAdjustmentPanel()}
                        <ResultsTable
                            componentViewPreference={componentViewPreference}
                            userIsConfigureComponentViewAdmin={userIsConfigureComponentViewAdmin}
                            componentViews={componentViews}
                            setActiveComponentView={setActiveComponentView}
                            activeComponentView={usageSearchResultsActiveComponentView}
                            key={setPageOne}
                            searchResultsTableData={searchResultsTableData}
                            tableContents={usageGroupsSearchResult}
                            settingsModalViewData={settingsModalViewData}
                            componentInstance={componentInstance}
                            indexOfFirstResult={indexOfFirstResult}
                            indexOfLastResult={indexOfLastResult}
                            resultsPerPage={resultsPerPage}
                            currentPage={currentPage}
                            updatePagination={updatePagination}
                            repertoireSection={SEARCH_VIEW_USAGES}
                            getUsageDetails={getUsageDetails}
                            getDistributionDetails={getDistributionDetails}
                            matchingSources={matchingSources}
                            getUsagePool={getUsagePool}
                            usageType={usageType}
                            onClickNumber={onClickNumber}
                            sortSearchResults={sortSearchResults}
                            distributions={distributions}
                            pools={pools}
                            lookupSources={lookupSources}
                            lookupValues={lookupValues}
                            changeData={this.changeData}
                            titleContains={titleContains}
                            search={this.onClickSearch}
                            continuationToken={continuationToken}
                            showFieldsModal={showFieldsModal}
                            updateUsageGroupMatches={updateUsageGroupMatches}
                            saveUsageGroup={saveUsageGroup}
                            saveResultData={saveResultData}
                            isHundredResultsPerPage={isHundredResultsPerPage}
                            setIsHundredResultsPerPage={setIsHundredResultsPerPage}
                            usageSearchResultConfiguration={usageSearchResultConfiguration}
                            usageNumberInSearchExclude={usageNumberInSearchExclude}
                            selectedUsageGroupIds={this.state.selectedUsageGroupIds}
                            onUsageGroupSelectionChanged={this.onUsageGroupSelectionChanged}
                            canUpdateUsages={this.props.canUpdateUsages === true}
                            canBulkAdjust={this.props.canBulkAdjust === true}
                            onUsageGroupSelected={this.props.onUsageGroupSelected}
                            singleUsageGroupSelection={this.props.singleUsageGroupSelection}
                            disableUsageOpen={this.props.disableUsageOpen}
                            bulkMatchPanelOpen={this.state.bulkMatchPanelOpen}
                            onBulkMatchSearch={this.openBulkMatchPanel}
                            bulkAdjustmentPanelOpen={this.state.bulkAdjustmentPanelOpen}
                            onBulkAdjustmentSearch={this.openBulkAdjustmentPanel}
                            externalLinks={this.props.externalLinks}
                            showModal={this.props.showModal}
                        />
                    </div>
                </div>)
            }
            else if (componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY &&
                matchProductsSearchResult && matchProductsSearchResult.length >= 1) {
                return (<div className="row">
                    <SelectionTable
                        key={setPageOne}
                        searchResultsTableData={searchResultsTableData}
                        tableContents={matchProductsSearchResult}
                        componentInstance={USAGE_MATCHING_PRODUCTS_SECTION_KEY}
                        onSelectResult={this.props.onSelectResult}
                        sourceItem={modalProps}
                        hideModal={undefined}
                        indexOfFirstResult={indexOfFirstResult}
                        indexOfLastResult={indexOfLastResult}
                        resultsPerPage={resultsPerPage}
                        currentPage={currentPage}
                        updatePagination={updatePagination}
                        repertoireSection={SEARCH_VIEW_USAGES}
                        expandedResults={expandedMatchWorkResults}
                        expandAll={usageExpandAll}
                        expandResult={expandMatchWorkResult}
                        expandAllResults={usageExpandAllResults}
                        addMatchProductToUsage={addMatchProductToUsage}
                        sortSearchResults={sortSearchResults}
                        getProductDetails={getProductDetails}
                        updateAdjustmentDetail={this.props.updateAdjustmentDetail}
                        adjustmentDetails={adjustmentDetails}
                        adjustment={adjustment}
                        workAdjustmentIndex={workAdjustmentIndex}
                        enabledAdjustmentICEWorkSearch={enabledAdjustmentICEWorkSearch}
                        showModal={showModal}
                        allocationRecords={allocationRecords}
                    />
                </div>)
            }
            else if (componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY &&
                matchWorkSearchResult && matchWorkSearchResult.length >= 1) {
                return (<div className="row">
                    <SelectionTable
                        key={setPageOne}
                        searchResultsTableData={searchResultsTableData}
                        tableContents={matchWorkSearchResult}
                        componentInstance={USAGE_MATCHING_WORKS_SECTION_KEY}
                        onSelectResult={this.props.onSelectResult}
                        sourceItem={modalProps}
                        hideModal={undefined}
                        lookupValues={lookupValues}
                        indexOfFirstResult={indexOfFirstResult}
                        indexOfLastResult={indexOfLastResult}
                        resultsPerPage={resultsPerPage}
                        currentPage={currentPage}
                        updatePagination={updatePagination}
                        repertoireSection={SEARCH_VIEW_USAGES}
                        expandedResults={expandedMatchWorkResults}
                        expandAll={usageExpandAll}
                        expandResult={expandMatchWorkResult}
                        expandAllResults={usageExpandAllResults}
                        addMatchworkToUsage={addMatchworkToUsage}
                        sortSearchResults={sortSearchResults}
                        getWorkDetails={getWorkDetails}
                        updateAdjustmentDetail={this.props.updateAdjustmentDetail}
                        adjustmentDetails={adjustmentDetails}
                        adjustment={adjustment}
                        workAdjustmentIndex={workAdjustmentIndex}
                        enabledAdjustmentICEWorkSearch={enabledAdjustmentICEWorkSearch}
                        showModal={showModal}
                        allocationRecords={allocationRecords}
                    />
                </div>)
            }
            else if (searchSuccessful == false) {
                return (
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 centerTextNotFound" >
                            Error while searching, please contact customer support if issue persists.
                        </div>
                    </div>
                )
            }
        }

    }
    resetToInitialState = () => {
        if (this.bulkAdjustmentSubmissionInFlight) {
            return;
        }

        this.sourceSelectionByUsageType = {};
        this.setState(initialState())
    }

    renderExtraFields = () => {
        const { isDistributed, dateOfRegistration, tabs, activeTab, componentInstance } = this.props;

        if (!tabs[activeTab].matchingWork) {
            return <div className="row">
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 centerTextNotFound" >
                    Loading
                </div>
            </div>;
        } else {
            return (
                <div className="searchFieldsGridUsageModal">
                    <div className="row">
                        <SizedCheckboxDataInput
                            label={"Is Distributed"}
                            fieldName={WORK_IS_DISTRIBUTED_STATE_KEY}
                            value={isDistributed}
                            changeData={null}
                            readonly={true}
                            isHidden={false} />
                    </div>
                    <div className="row">
                        <SizedDateDataInput
                            label={"Registration Date"}
                            fieldName={REG_DATE_STATE_KEY}
                            value={dateOfRegistration ? dateOfRegistration : ""}
                            changeData={null}
                            readOnly={true}
                            isHidden={false} />
                    </div>
                </div>
            )
        }

    }

    render() {
        const { onlySearchResults, searchDisabled, searchType, componentInstance } = this.props;

        if (onlySearchResults) {
            return (
                <div className={USAGE_MATCHING_PRODUCTS_SECTION_KEY !== componentInstance && "searchView"}>
                    <div className="row">
                        {this.renderExtraFields()}
                    </div>
                    <div>
                        {this.renderSearchResults()}
                    </div>
                </div>
            )
        } else {
            return (
                <div className={USAGE_MATCHING_PRODUCTS_SECTION_KEY !== componentInstance && "searchView"}>
                    <div className="row">
                        <SearchViewKeyEventListener setStateInitial={this.resetToInitialState.bind(this)} componentInstance={componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY || componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY  ? USAGE_MAINTENANCE_PAGE_KEY : SEARCH_VIEW_USAGES} onSave={() => this.onClickSearch()} />
                        {this.renderSearchFields()}
                    </div>
                    {searchType === ADVANCED &&
                        <>
                            <div className="headerSection">Advanced</div>
                            <div className="row">
                                {this.renderSearchFields(ADVANCED)}
                            </div>
                        </>
                    }
                    <div className="row">
                        <div className="form-group col-lg-4 col-lg-push-8 col-md-4 col-md-push-8 col-sm-6 col-sm-push-6 col-xs-12 col-xs-push-0">
                            <CustomButton buttonText="Search" buttonAction={() => this.onClickSearch()} disabled={searchDisabled} />
                        </div>
                    </div>
                    <div>
                        {this.renderSearchResults()}
                    </div>
                </div>
            )
        }
    }
}
